import {
  REPORT_DONE_STATUS,
  STUDY_SEARCH_RESULTS_ID,
  TAB_NAME,
} from "../../../constants/Constants";


export const getEffectiveWorkflowTab = (study) => {
  if (!study) {
    return TAB_NAME.UNREPORTED;
  }
  const assignment = study.assignmentList?.[0] || {};
  const status =
    study.reportDoneStatus != null
      ? study.reportDoneStatus
      : assignment.reportDoneStatus;

  const accessStatus = study.archivedStudyAccessRequestDto?.status;
  if (accessStatus === "PENDING") return TAB_NAME.PENDING;
  if (accessStatus === "APPROVED") return TAB_NAME.APPROVED;
  if (accessStatus === "REJECTED") return TAB_NAME.REJECTED;

  const closed = assignment.closed != null ? assignment.closed : study.closed;
  if (closed != null && Number(closed) > 0) {
    return TAB_NAME.CLOSED;
  }

  if (
    status === REPORT_DONE_STATUS.QCREVIEW ||
    status === REPORT_DONE_STATUS.PRELIMINARY_QC_REVIEW
  ) {
    return TAB_NAME.QCREVIEW;
  }
  if (
    status === REPORT_DONE_STATUS.QCFIX ||
    status === REPORT_DONE_STATUS.PRELIMINARY_QC_FIX
  ) {
    return TAB_NAME.QCFIX;
  }
  if (
    status === REPORT_DONE_STATUS.QCVERIFY ||
    status === REPORT_DONE_STATUS.PRELIMINARY_QC_VERIFY
  ) {
    return TAB_NAME.QCVERIFY;
  }
  if (status === REPORT_DONE_STATUS.REPORTED) {
    return TAB_NAME.REPORTED;
  }
  if (
    status === REPORT_DONE_STATUS.SAVED ||
    status === REPORT_DONE_STATUS.PRELIMINARY
  ) {
    return TAB_NAME.SAVED;
  }
  if (status === REPORT_DONE_STATUS.DRAFT) {
    return TAB_NAME.DRAFT;
  }
  return TAB_NAME.UNREPORTED;
};

export const WORKFLOW_TAB_BADGE = {
  [TAB_NAME.UNREPORTED]: { label: "Unreported", color: { background: "#8E8E8E", color: "#FFFFFF" } },
  [TAB_NAME.SAVED]: { label: "Preliminary", color: { background: "#B99A40", color: "#FFFFFF" } },
  [TAB_NAME.DRAFT]: { label: "Draft", color: { background: "#8E8E8E", color: "#FFFFFF" } },
  [TAB_NAME.REPORTED]: { label: "Reported", color: { background: "#6DA370", color: "#FFFFFF" } },
  [TAB_NAME.CLOSED]: { label: "Closed", color: { background: "#6B7280", color: "#FFFFFF" } },
  [TAB_NAME.QCREVIEW]: { label: "QC Review", color: { background: "#5627A4", color: "#FFFFFF" } },
  [TAB_NAME.QCFIX]: { label: "QC Fix", color: { background: "#C4664C", color: "#FFFFFF" } },
  [TAB_NAME.QCVERIFY]: { label: "QC Verify", color: { background: "#73A53A", color: "#FFFFFF" } },
  [TAB_NAME.RETURNED]: { label: "Returned", color: { background: "#59ADFA", color: "#033462" } },
  [TAB_NAME.PENDING]: { label: "Pending", color: { background: "#FFC75A", color: "#312404" } },
  [TAB_NAME.APPROVED]: { label: "Approved", color: { background: "#6DA370", color: "#FFFFFF" } },
  [TAB_NAME.REJECTED]: { label: "Rejected", color: { background: "#E37475", color: "#FFFFFF" } },
};

/** Search Results list tab id(s) used by table container / headers. */
export const isGlobalSearchResultsTab = (listTabId) =>
  listTabId === TAB_NAME.ALL || listTabId === STUDY_SEARCH_RESULTS_ID;

export const EMPTY_GLOBAL_SEARCH_MESSAGE =
  "Please enter a search value or apply a filter to view All Tabs";

export const hasSearchBoxValue = (searchDto) =>
  (searchDto?.orderId != null && searchDto.orderId.trim().length > 0) ||
  (searchDto?.patientNameOrId != null && searchDto.patientNameOrId.trim().length > 0) ||
  (searchDto?.accessionNumber != null && searchDto.accessionNumber.trim().length > 0) ||
  (searchDto?.keyword != null && searchDto.keyword.trim().length > 0) ||
  (searchDto?.studyDescription != null && searchDto.studyDescription.trim().length > 0);

export const hasAppliedFilters = (searchDto) =>
  (searchDto?.modalityIds != null && searchDto.modalityIds.length > 0) ||
  (searchDto?.subModalityIds != null && searchDto.subModalityIds.length > 0) ||
  (searchDto?.clientOrFirmIds != null && searchDto.clientOrFirmIds.length > 0) ||
  (searchDto?.providerIds != null && searchDto.providerIds.length > 0) ||
  (searchDto?.classificationIds != null && searchDto.classificationIds.length > 0) ||
  (searchDto?.annotationId != null && searchDto.annotationId !== "") ||
  (searchDto?.aiPredictionId != null && searchDto.aiPredictionId !== "") ||
  (searchDto?.studyDateFrom != null && searchDto.studyDateFrom !== "") ||
  (searchDto?.studyDateTo != null && searchDto.studyDateTo !== "") ||
  (searchDto?.reportDateFrom != null && searchDto.reportDateFrom !== "") ||
  (searchDto?.reportDateTo != null && searchDto.reportDateTo !== "") ||
  (searchDto?.historyChecks != null && searchDto.historyChecks !== 0) ||
  (searchDto?.uploadDate != null && searchDto.uploadDate !== "") ||
  (searchDto?.noOfImages != null)||
  (searchDto?.studyPriorityValues != null && searchDto.studyPriorityValues.length > 0);

export const hasGlobalSearchCriteria = (searchDto) =>
  hasSearchBoxValue(searchDto) || hasAppliedFilters(searchDto);

export const resolveTabIdForRow = (listTabId, study) => {
  if (isGlobalSearchResultsTab(listTabId)) {
    return getEffectiveWorkflowTab(study);
  }
  return listTabId;
};


export const GLOBAL_SEARCH_ACTION_MENU_KEYS = [
  "TAT",
  "viewReportHistory",
  "ShareStudyLink",
  "ViewAuditLogs",
  "Reinference",
];


export const filterActionMenuForGlobalSearch = (items, effectiveTabId) => {
  if (!Array.isArray(items)) {
    return [];
  }
  const allowed = new Set(GLOBAL_SEARCH_ACTION_MENU_KEYS);
  const isClosed = effectiveTabId === TAB_NAME.CLOSED;
  const isReported = effectiveTabId === TAB_NAME.REPORTED;

  return items.filter((item) => {
    if (!item || !allowed.has(item.key)) {
      return false;
    }
    if (item.key === "ShareStudyLink" && isClosed) {
      return false;
    }
    if (item.key === "Reinference" && (isReported || isClosed)) {
      return false;
    }
    return true;
  });
};

